<template>
  <div class="join-our">
    <div class="row w-100 d-flex">
      <div class="join-for col-5">
        <h2 class="txt-join">Join Our Community</h2>
        <p class="txt-for">for a better future</p>
      </div>
      <div class="col-5">
        <a
          href="https://t.me/+2_OmvDH61u01NTQ1"
          target="_blank"
          @click="GetClickUser"
          class="btn-join"
          >Join Now</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: `JoinOur`,
};
</script>

<style>
.join-our {
  margin-bottom: 300px;
}
.btn-join {
  width: 160px;
  height: 50px;
  margin-left: 100px;
  margin-top: 5px;
  border-radius: 50px;
  background-color: #f74d00;
  border: #f74d00;
  font-size: 16px;
}
.btn-join {
  cursor: pointer;
  text-decoration: none;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border: 1px solid #f74d00;
}
.btn-join:hover {
  background-color: white;
  color: black;
  border: 1px solid black;
}

@media screen and (min-width: 320px) {
  .join-our {
    margin: 4rem 0;
  }

  .join-for {
    margin-left: 130px;
  }
  .txt-join {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: #2b312e;
  }
  .txt-for {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #aeafae;
  }
}
</style>
